import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {selectFirmware_124_4_4_RelatedTargetSerialNumber} from '../../state/selectors/iotDevice';
import helpers from '../../utils/helpers';
import useFirmwareReleaseNotes from './useFirmwareReleaseNotes';

const useFirmwareReleaseNotesBanner = () => {
    const serialNumber = useSelector(selectFirmware_124_4_4_RelatedTargetSerialNumber);
    const {getFirmwareReleaseNotesData, removeFirmwareReleaseNotesBannerData} = useFirmwareReleaseNotes();

    useEffect(() => {
        if (!serialNumber) return;
        const {isFwUpgraded, wasReleaseNotesShown} = getFirmwareReleaseNotesData?.() || {};

        if (isFwUpgraded && wasReleaseNotesShown) {
            helpers.runFunction(removeFirmwareReleaseNotesBannerData);
        }
    }, [serialNumber]);
};

export default useFirmwareReleaseNotesBanner;
